import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-email-sms-placeholder',
  templateUrl: './email-sms-placeholder.component.pug',
  styleUrls: ['./email-sms-placeholder.component.scss'],
  standalone: false
})
export class EmailSmsPlaceholderComponent {

  @Input() placeholders: any;
  @Input() showSMS = true;

}
